export enum VisibilityLevel {
  Admin,
  Title,
  PublicUser,
  GeneralPublic
}
